export const addQuestionAction = function (item, form) {
    return {
        type: "FB_ADD_QUESTION",
        payload: item, 
        form
    }
};

export const setQuestionsAction = function (items, form) {
    return {
        type: "FB_SET_QUESTIONS",
        payload: items, 
        form
    }
};

export const removeQuestionAction = function (item, form) {
    return {
        type: "FB_REMOVE_QUESTION",
        payload: item, 
        form
    }
};

export const clearQuestionsAction = function () {
    return {
        type: "FB_CLEAR_QUESTIONS"
    }
};


export const changeQuestionAction = function (item, form) {
    return {
        type: "FB_CHANGE_QUESTION",
        payload: item, 
        form
    }
};


// WEBPACK FOOTER //
// ./src/redux/creators/form-builder/questions.js